export const CODEFORGE_BATCH_MASTER =

 [
  {
    rollNo: "25B11AI014",
    name: "ADIGARLA JAHNAVI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI026",
    name: "ALA YUGANDHAR",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AI073",
    name: "AVASARALA PRABHA JAAHNAVI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11AI130",
    name: "BIGUVU VYAS SRI NANDAN",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI138",
    name: "BODDU SRIRAM RATNA KUMAR",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI156",
    name: "BOYA PRATHAP",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI157",
    name: "BOYIDI LALITHA SUNDARI DEVI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI184",
    name: "CHAVAKULA SRI TEJASWINI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11AI216",
    name: "CHINTHA SAI KARTHIKEYAN",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI223",
    name: "CHIRLA SRI SAI CHARAN TEJA REDDY",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI241",
    name: "DR PALGUN",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI247",
    name: "DANDE LENANDAN NARASIMHA SAI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI267",
    name: "DHANAKONDA AMMULU",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI273",
    name: "DODDI CHAITANYA LAKSHMI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI305",
    name: "GADERAJU NIKHILESH VARMA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI311",
    name: "GANDHAM MOHANA SRIRAM",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI324",
    name: "GANTI BRAHMANI NAGA SAI LAKSHMI BHAVYA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11AI356",
    name: "GONABOYINA LAHARI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI379",
    name: "VISHNU PRIYA GUMMA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI428",
    name: "JOJATI BHAKAT",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI434",
    name: "JYOTHI KUNCHALA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11AI478",
    name: "KANDRU ASHOK",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI495",
    name: "KAPPARATI LOKESH SATYA SAI BABU",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI528",
    name: "KETHAMALLA VEERA CHANIKYA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI570",
    name: "KOPPALA DEVI SRI CHARAN",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI578",
    name: "KORUMILLI HARSHA VARDHAN",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI589",
    name: "KOTHAPALLI ANJANEYA VENKATA MANIKANTA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI606",
    name: "KRANTHI NAKKA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI611",
    name: "KUMMARA NAVEEN KUMAR",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI709",
    name: "MAROTHU CHANDRASEKHAR",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI730",
    name: "MEDISETTI SAI SHANMUKHI SIRI CHANDANA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI753",
    name: "MOHAMMED SHARIQ ZAMA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI755",
    name: "MOLLETI RAVI TEJA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI835",
    name: "NEELAMSETTI SUBHASH",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI839",
    name: "NEETIPALLI SATYA SAI HANUMA PHANINDRA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11AI868",
    name: "PADALA MEGHANA LAKSHMI SAI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AI892",
    name: "PAMURI VENKATA SAI ROHITH REDDY",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AI924",
    name: "PEDDINTI GOPI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AI978",
    name: "POTHURAJU PRAPURNA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11AI991",
    name: "PUNYAMANTHULA LAKSHMIPRASANNA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Female"
  },
  {
    rollNo: "25B11AIA79",
    name: "SATYA NANDA KISHORE GOPI",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AIA90",
    name: "SHAIK ABDUL RAJAK",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AIA91",
    name: "SHAIK ABDUL SATTAR",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AIB59",
    name: "SYED SAIF HUSSAIN",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AIB79",
    name: "TEJESWARA DURGA LAXMI NARASIMHA DOOLLA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11AIC61",
    name: "LAKSHMI GANGA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11AIC73",
    name: "VENKATA MADHURI POTHULA",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },

  // CSE - Advanced
  {
    rollNo: "25B11CS057",
    name: "NITYA ANVESH MYNAM",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS115",
    name: "BODDU LAKSHMI SURYA SAHITHI",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11CS148",
    name: "CHARAF KAMBAGIRI KAMAL BASHA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS149",
    name: "CHARAN SAI VENKATA RAJU KATTA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS194",
    name: "CHOKKA SRI SOWMYA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11CS225",
    name: "DESALLA HEMANTH",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS349",
    name: "JASWANTH KATRAGADDA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS381",
    name: "KAMEPALLI VENKATA AKHILESH",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS387",
    name: "KANCHAM RAM CHARAN",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS396",
    name: "KANTIBOINA PADMASRI KRUPA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11CS473",
    name: "KOSURI TEJA SAMPATH VINAY",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS483",
    name: "KOTHAPALLI VITESH KRISHNA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS504",
    name: "KURUTHALLA JOEL JASON",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS507",
    name: "LACCHIREDDY MANJULA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11CS513",
    name: "LANKA BALA TRIPURA SUNDARI",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11CS570",
    name: "MANTHENA NAGA SIVA SAI SRI SNEHIT VARMA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS596",
    name: "MEDISETTY SRI SAI MANIKANTA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS623",
    name: "MUPPANABOINA VAMSI KALYAN",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS631",
    name: "MUTYALA SIVA MURALI KRISHNA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS650",
    name: "NALLAMILLI SAVITHA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11CS676",
    name: "NIKHIL BANTUPALLI",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS692",
    name: "PADALA ABHI VARUN REDDY",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS718",
    name: "PASALA HARINI",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11CS731",
    name: "PEDDAKOTLA SAI ROHITH",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS737",
    name: "PEESAPATI BALA SHANMUKHA ADITHYA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS746",
    name: "PENTELA RAGHURAM",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS760",
    name: "PODUGU ANUSRI",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11CS772",
    name: "POSANI NITHILAN",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS787",
    name: "PULAGAM DIVYA VEERA RAMTEJA REDDY",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS809",
    name: "RAMOJU SURYA VENKATA SAI PRAKASH",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS810",
    name: "RAVADA VINAY",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS836",
    name: "RUSHIL GARA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS839",
    name: "SALADI VEERA SAI ANUSHA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11CS855",
    name: "SANTHA THANUJA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11CS861",
    name: "SATTI LEELA VENKATA KRISHNA REDDY",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS876",
    name: "SHAIK ABUBAKAR SIDDIQ",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11CS904",
    name: "SIRIGIREDDY VIJAYA KUMAR REDDY",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS907",
    name: "SIRIVELLA SYAM SUNDHAR",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },
  {
    rollNo: "25B11CS954",
    name: "TIRUMANI SAI PAVAN",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CS972",
    name: "U AKSHAYA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: ""
  },
  {
    rollNo: "25B11CS986",
    name: "ALEKHYA VANACHERLA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11CSA00",
    name: "VEERA PRANAV ADITYA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11CSA06",
    name: "VELAGALA SURYA KOTI SANTOSH KUMAR REDDY",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CSA24",
    name: "Vivek Guvvabathina",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Arjun",
    gender: "Male"
  },
  {
    rollNo: "25B11CSA29",
    name: "KASI ANNAPURNA VUTA",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11CSA46",
    name: "Kowshik Kumar Yanamala",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11CSA48",
    name: "YANAMALA ROHITH",
    branch: "CSE",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11DS021",
    name: "ANANTHAPALLI TEJASWI",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Female"
  },
  {
    rollNo: "25B11DS182",
    name: "GULLAPUDI HEMA SRI",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11DS190",
    name: "GURALA RATAN TEJA",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11DS472",
    name: "RANGINEEDI RATNA KISHORE",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11DS495",
    name: "SAILADA GNANASWAROOP",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11DS518",
    name: "SHAIK ATHIK",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11DS550",
    name: "SUNKARA GNANADEEP REDDY",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11DS581",
    name: "THUMU AVINASH REDDY",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "25B11DS607",
    name: "VINJAVARAPU SWARUPA",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Female"
  },
  {
    rollNo: "25B11DS629",
    name: "LOCHAN YERRU",
    branch: "DS",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Siva",
    gender: "Male"
  },
  {
    rollNo: "26B21AI021",
    name: "CHIRLA MANOJ SAI KUMAR REDDY",
    branch: "AIML",
    codingBatch: "Advanced",
    mentor: "Ashok",
    poolMentor: "Sai",
    gender: "Male"
  },

  // Beginner-B1
  {
    rollNo: "25B11AI052",
    name: "ANNAPAREDDY PAVAN KUMAR REDDY",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI075",
    name: "AVULA VENKATA NAVEEN",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI086",
    name: "BAMMIDI MEGHANA MAHESWARI",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11AI105",
    name: "BATTINA LAKSHMI HASINI",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11AI161",
    name: "BUDIDHA LAHARI PRIYA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11AI182",
    name: "CHAMAKURI PHANESWAR",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI204",
    name: "CHILAKA JASWIN",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI211",
    name: "SUJATHA CHINTA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11AI286",
    name: "DWARAMPUDI DHANESWARI",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11AI291",
    name: "EDUMALLI DHARANI",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11AI333",
    name: "GEDE JASWANTH REDDY",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11AI364",
    name: "GRANDHI S D S ANUNAGA JASWANTH RAJKUMAR",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11AI399",
    name: "GUTTULA SYAMYUL TEJA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI669",
    name: "NAKIREKANTI MARYGRACE",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11AI670",
    name: "MAKKE VENKATA REVANTH",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI768",
    name: "MUDEDLA PUSHPA SRI SUJANA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11AI773",
    name: "MULAKALA VIVEK SURYA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11AI812",
    name: "NALLURI LEELA SOWMYA SRI",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11AI813",
    name: "NALLURI SAI KAMALESH ANAND CHOWDARY",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11AI822",
    name: "NARAHARISETTI NIKHITHA SYAMALA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11AI866",
    name: "PABOLU VENKATA PAVAN",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI893",
    name: "PANDA VAISHANTH",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11AI899",
    name: "PAVAN AKSHAY",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AI919",
    name: "PAYASAM SRIRAMA CHANDRA KARTHIK",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11AIA33",
    name: "REPAKA DHARSHA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11AIA37",
    name: "RISHITHA PHANI SATYA SAI VANI BADDI",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11AIA46",
    name: "SACHIN KUMAR",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11CS012",
    name: "ADAPA NITYA SRI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11CS047",
    name: "ANASURI HARICHARANI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS164",
    name: "CHEVA SRI SIVA RAMA SAILESH",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11CS209",
    name: "D. PRANEELA",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11CS327",
    name: "GUNNAM SUDHEER",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11CS334",
    name: "G DIVYA SRI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS348",
    name: "J SRAVYA RATNA HARSHA",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS357",
    name: "SURLA VIJAYARAMUDU",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11CS377",
    name: "KALAPALA NAVADEEP",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11CS669",
    name: "NAVA VARA LAKSHMI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS756",
    name: "GNANESWARI PILLI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11CS796",
    name: "PUPPALA AMRUTA NAGA SINDU",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS851",
    name: "SANGISETTI UDAYA SATYA",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS860",
    name: "SATHI VIJAYA LAKSHMI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS863",
    name: "SATYAM S NAGGH JYOTI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11CS979",
    name: "VADDI, SUDEEPTHI",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25b11csa74",
    name: "MOREBLESSING SVOVA",
    branch: "CSE",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11DS006",
    name: "A. Balaji",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11DS022",
    name: "ANDE GOPICHAND REDDY",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11DS131",
    name: "EDE CHAITANYA KRISHNA KISHIK",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11DS160",
    name: "TEJASWI GOGINENI",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11DS245",
    name: "Kedarisetti Satya Nagendra",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11DS289",
    name: "KUMMARA MOKSHITHA",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11DS306",
    name: "M RITHVIK VIVEK",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11DS409",
    name: "PALUKURI RAGHU CHANDRA SRI VIVEK",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11DS517",
    name: "ASHIFA SHAIK",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11DS519",
    name: "SHAIK BHANU SHAILU",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11DS525",
    name: "S.P AYESHA",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11DS547",
    name: "SUDARSANAM SRI MANOJ KUMAR",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Male"
  },
  {
    rollNo: "25B11DS574",
    name: "THANDRA LAVANYA",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11DS583",
    name: "TIPPARNA NANDINI",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "25B11DS590",
    name: "UTTAM MAHTO",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },
  {
    rollNo: "25B11DS610",
    name: "VUMMITI GURUSAI THILAK",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Male"
  },

  // Intermediate-B1
  {
    rollNo: "25B11AIC87",
    name: "Y MOHITHA",
    branch: "AIML",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Female"
  },
  {
    rollNo: "25B11CS010",
    name: "ADAPA CHARWITHA SAI SANTHOSHI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS029",
    name: "AKULA VIMALA SRI HANSIKA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS043",
    name: "ANALA LOKESWAR",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Male"
  },
  {
    rollNo: "25B11CS054",
    name: "A VEERA MANOJ",
    branch: "CSE",
    codingBatch: "intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS056",
    name: "ANUSURI MAHESH",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Male"
  },
  {
    rollNo: "25B11CS062",
    name: "ARIMILLI ANANYA",
    branch: "CSE",
    codingBatch: "intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS073",
    name: "LESLIE KUDAKWASHE CHIBUMBA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Male"
  },
  {
    rollNo: "25B11CS074",
    name: "TATANGA ILARD CHIKANDIWA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Male"
  },
  {
    rollNo: "25B11CS101",
    name: "BETHA DINESH RAJU",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS113",
    name: "B VAGDEVI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS134",
    name: "BURRA BHUVANESWARI VENKATA LAKSHMI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS151",
    name: "CHEERLA JAYA DURGA SREE",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS152",
    name: "CHEKURI YASHWIKA VARMA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS203",
    name: "DAMARLA MAHESWARI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS210",
    name: "DANGETI TORANA SRIJA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS216",
    name: "DARAPUREDDY HARSHINI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS236",
    name: "DIPTRISHA DAS",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS243",
    name: "NADIPINENI HARSHAVARDHAN",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS250",
    name: "DUSARLAPUDI VIJAY SUDARSHAN",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Male"
  },
  {
    rollNo: "25B11CS253",
    name: "EERANKI SRI SURYA KRISHNA KARTHIK",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Male"
  },
  {
    rollNo: "25B11CS261",
    name: "G SAI SRI KEERTHI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS306",
    name: "GRANDHI SAHASRA NAGAVENKATA SRIMAHALAKSHM",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS311",
    name: "GUBBALA KEERTHANA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS429",
    name: "KHAN SHABREEN",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS435",
    name: "DUMOLWAKHE NDLOVU",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Male"
  },
  {
    rollNo: "25B11CS444",
    name: "MONIKA NAGESWARI KOMALI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS453",
    name: "KONAGALLA SURYA RAJA MOKSHAGNA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS467",
    name: "KOPPISETTI SIVANI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Pavan",
    gender: "Female"
  },
  {
    rollNo: "25B11CS494",
    name: "KSHATRI VISHNU BALAJI SUMITH SINGH",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS517",
    name: "LAVETI ROSHINI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Female"
  },
  {
    rollNo: "25B11CS624",
    name: "MURALA SAHITH KUMAR",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS658",
    name: "NAMMI HEMA MADHURI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Female"
  },
  {
    rollNo: "25B11CS677",
    name: "NIMISHA MAITY",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Female"
  },
  {
    rollNo: "25B11CS689",
    name: "PADALA LAHARI",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Female"
  },
  {
    rollNo: "25B11CS700",
    name: "PALIVELA PRAHARSHA SAI CHARAN",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS715",
    name: "PARNAPALLI CHANDRAKANTH",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS717",
    name: "PARUPALLI SURYA AKHIL",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS752",
    name: "PERURI SURYA SATYA ROHITH KUMAR",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS767",
    name: "POLURI SESHA SAINA PRANEETH",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS778",
    name: "P SRIJA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Female"
  },
  {
    rollNo: "25B11CS803",
    name: "VEERA BABU THOTAKURA",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS822",
    name: "R M ABBAS",
    branch: "CSE",
    codingBatch: "intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CS985",
    name: "VALLURI ANIRUDH",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "25B11CSA88",
    name: "MATHUKUMILLI SAI SATYA SRIKAR",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },
  {
    rollNo: "26B21CS058",
    name: "MAGAPU VIJAYA PARDHU",
    branch: "CSE",
    codingBatch: "Intermediate-B1",
    mentor: "Pavan",
    poolMentor: "Mutyalababu",
    gender: "Male"
  },

  // Intermediate-B2
  {
    rollNo: "25B11AI009",
    name: "ADARSH SIDDHARTH",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11AI039",
    name: "ANDAVARAPU OMKAR",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11AI044",
    name: "ANIKET KUMAR",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11AI074",
    name: "AVULA LOKESH",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11AI125",
    name: "K SHYAM",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11AI131",
    name: "BIKKINA KEERTHI VARSHITHA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11AI147",
    name: "BOMMADEVARA SWATHI SRI SATYADURGA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11AI150",
    name: "BONEPALLI NIVEDITHA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11AI242",
    name: "GIRI BABU DAKUDORA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11AI271",
    name: "DHAVALA HANSHITHA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11AI350",
    name: "GOLLAPALLI VENKATA SATYA PADMA RAJYAM",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11AI361",
    name: "GOPIREDDY DILEEP",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11AI381",
    name: "GUMMALLA JAHNAVI SAI BHAVANI",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11AI474",
    name: "S RAJESH",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11AI581",
    name: "KOSANAM BALA ADITYA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11AI587",
    name: "KOTANA SAI SASHANK",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11AI705",
    name: "MARGANA SUMALATHA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11AI765",
    name: "MUDAY MOHITH NAIK",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11AI770",
    name: "MUKE KEERTHANA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11AI803",
    name: "NAKKALA HEMA VARSHINI",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11AI898",
    name: "PAPANA LAHARI DEVI",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11AI934",
    name: "PENKE LOKA DURGA PRIYA",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11AI961",
    name: "PITCHUKA RAVI RAJ",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11AIC31",
    name: "VELPUKONDA MANOJ PRASAD",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11AIC55",
    name: "GANUSAI VECHALAPU",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11DS018",
    name: "ALLURI ESWAR VARMA",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11DS082",
    name: "GUDIMETLA MONIKA RAMYA",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11DS083",
    name: "T MEGHANA",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11DS181",
    name: "GUJJULA SIDDARDHA REDDY",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "25B11DS210",
    name: "KAKARAPARTHI LAKSHMI CHARAN",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11DS465",
    name: "RAJALA AVINASH",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11DS515",
    name: "SHAHUKARI ROHITH",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11DS531",
    name: "SHEIK SHADHIQ",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11DS542",
    name: "SIRISOLLA DIVYA SRI",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11DS543",
    name: "SIRIVELLA V V S D P MAHALAKSHMI SUJATHA",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Female"
  },
  {
    rollNo: "25B11DS615",
    name: "YALURU CHARITHA REDDY",
    branch: "DS",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Female"
  },
  {
    rollNo: "25B11IT044",
    name: "KARNATA ABHINAV",
    branch: "IT",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  },
  {
    rollNo: "26B21AI112",
    name: "VALLURI SAI SREE NAVYA",
    branch: "AIML",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Tarak",
    gender: "Female"
  },
  {
    rollNo: "25B11IT105",
    name: "TELAGAMSETTI ABHILASH",
    branch: "IT",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Ajith",
    gender: "Male"
  },
  {
    rollNo: "25B11DS370",
    name: "N AKHILA DEVI",
    branch: "DS",
    codingBatch: "Beginner-B1",
    mentor: "Ganapathi",
    poolMentor: "Ganapathi",
    gender: "Female"
  },
  {
    rollNo: "26B21AI022",
    name: "DADISETTY SAI PRAVEEN KUMAR",
    branch: "AIML",
    codingBatch: "Intermediate-B2",
    mentor: "Ajith",
    poolMentor: "Hanumanthu",
    gender: "Male"
  }
];